import { Component } from '@angular/core';

@Component({
    selector: 'app-key-gen-app-layout',
    templateUrl: './key-gen-app-layout.component.html',
    styleUrl: './key-gen-app-layout.component.css',
    standalone: false
})
export class KeyGenAppLayoutComponent {

}
